export default {
  title: '! Ordrer sat på pause til {{time}}',
  button: 'Genoptag',
  labels: {
    rest_of_day: 'resten af dagen',
  },
};
